<div class="header">
  <div class="title">Add View</div>
  <ts-button
    class="close-button"
    type="icon"
    htmlButtonType="button"
    icon="ts_close"
    (buttonClick)="discard()"
    [tabIndex]="-1"
  ></ts-button>
</div>

<form [formGroup]="addPipelineForm">
  <!-- Subject -->
  <mat-form-field class="subject">
    <mat-label>View Name</mat-label>
    <input matInput [formControlName]="'name'" data-cy="form-view-name-text-form-field" />
    <mat-error *ngIf="addPipelineForm.get('name').hasError('duplicateName')">
      This name already exists. Please choose a different name.
    </mat-error>
  </mat-form-field>

  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <ts-button variant="secondary" class="discard-button" htmlButtonType="button" (buttonClick)="discard()">
        <span>Cancel</span>
      </ts-button>

      <!-- Send -->
      <ts-button
        variant="primary"
        class="send-button"
        htmlButtonType="submit"
        [disabled]="addPipelineForm.disabled || addPipelineForm.pristine || addPipelineForm.invalid"
        (buttonClick)="save()"
        data-cy="save-view-button"
      >
        <span>Save</span>
      </ts-button>
    </div>
  </div>
</form>
